import useAnalyticsContext from '@client/hooks/useAnalyticsContext';
import AnalyticsConstants from '@constants/analytics';
import { useCallback } from 'react';
import type { SeasonType } from '..';

export const useTrackSeasonalToggle = () => {
	const { track } = useAnalyticsContext();

	return useCallback(
		(season: SeasonType) => {
			track({
				event: AnalyticsConstants.BUTTON_CLICKED,
				properties: {
					product_area: 'marketplace',
					button_clicked: season === 'peak' ? 'peak season' : 'off-peak season',
					storefront_block: 'pricing',
				},
			});
		},
		[track],
	);
};
